"use client";

import { useEffect, useRef } from "react";

import { trackViewContent, type TrackProduct } from "@/lib/tracking/ecommerce-events";

interface ProductViewTrackerProps {
  product: TrackProduct;
}

/**
 * Fires a Facebook Pixel `ViewContent` once per product on mount. Rendered on
 * the product detail page. No-op when the pixel isn't loaded; the ref guard
 * prevents a duplicate fire from React strict-mode double-invoke or a client
 * re-render for the same product.
 */
export function ProductViewTracker({ product }: ProductViewTrackerProps) {
  const firedForId = useRef<string | null>(null);

  useEffect(() => {
    if (!product?.id || firedForId.current === product.id) return;
    firedForId.current = product.id;
    trackViewContent(product);
  }, [product]);

  return null;
}
